import { membershipNameType } from './constant'

export const APRIL_STANDARD_PROMO = {
	couponCode: 'UNESCO2026',
	billing: 'yearly' as const,
	startDate: new Date('2026-04-20T16:00:00Z'), // Apr 21, 12:00am HKT
	endDate: new Date('2026-04-24T13:00:00Z'), // Apr 24, 9:00pm HKT
	regularMonthlyPrice: 15,
	regularYearlyPrice: 180,
	promoMonthlyEquivalent: 7.5,
	promoYearlyPrice: 90,
	discountPercent: 50,
} as const

export type PromoTimeLeft = {
  days: number
  hours: number
  minutes: number
  seconds: number
}

const emptyTimeLeft = (): PromoTimeLeft => ({
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
})

export function isAprilStandardPromoActive(now: Date = new Date()): boolean {
  return now >= APRIL_STANDARD_PROMO.startDate && now <= APRIL_STANDARD_PROMO.endDate
}

export function getAprilStandardPromoEndDate(): Date {
  return APRIL_STANDARD_PROMO.endDate
}

export function getAprilStandardPromoTimeLeft(now: Date = new Date()): PromoTimeLeft {
  const diff = APRIL_STANDARD_PROMO.endDate.getTime() - now.getTime()

  if (diff <= 0) {
    return emptyTimeLeft()
  }

  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  }
}

export function isUserEligibleForAprilStandardPromoBanner(membershipName?: string): boolean {
  if (!isAprilStandardPromoActive()) return false
  if (!membershipName) return false

  return (
    membershipName !== membershipNameType.Standard &&
    membershipName !== membershipNameType.Pro &&
    membershipName !== membershipNameType.Teacher
  )
}

export function shouldApplyAprilStandardPromoToPlan({
  planValue,
  billing,
  isCurrentPlan,
  hasManualCoupon,
  now = new Date(),
}: {
  planValue: string
  billing: 'monthly' | 'yearly'
  isCurrentPlan: boolean
  hasManualCoupon: boolean
  now?: Date
}): boolean {
  if (!isAprilStandardPromoActive(now)) return false
  if (hasManualCoupon) return false
  if (isCurrentPlan) return false

  return planValue === membershipNameType.Standard && billing === APRIL_STANDARD_PROMO.billing
}
